import { reduxField } from '../../../reduxHelpers'
const { reducer, actions, saga } = reduxField.HR.PERSONAL_DETAILS()
export { reducer, actions, saga }
